import { createFileRoute } from "@tanstack/react-router";
import { DashboardLayout } from "@/components/dashboard-layout";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { GatewaysTable } from "./-components/gateways-table";
import { useMemo, useState, useEffect } from "react";
import { gatewaysQueryOptions } from "@/server/gateways";
import { toast } from "sonner";

type GatewayParams = {
  gatewayId?: string;
};

export const Route = createFileRoute("/_dashboard/gateways")({
  component: RouteComponent,
  loader: ({ params }: { params: GatewayParams }) => {
    return {
      gatewayId: params.gatewayId,
      crumb: "Gateways",
    };
  },
});

function RouteComponent({}) {
  const [staleTime, setStaleTime] = useState(1000 * 60);

  useEffect(() => {
    const savedStaleTime = localStorage.getItem("staleTime");
    if (savedStaleTime) {
      setStaleTime(Number(savedStaleTime));
    }
  }, []);

  const queryOptions = useMemo(() => gatewaysQueryOptions(staleTime), [staleTime]);

  const gatewaysQuery = useQuery(queryOptions);
  const gateways = gatewaysQuery.data;

  const handleStaleTimeChange = (value: string) => {
    setStaleTime(Number(value));
    localStorage.setItem("staleTime", value);
  };

  useEffect(() => {
    if (gatewaysQuery.isError) {
      const message =
        gatewaysQuery.error instanceof Error
          ? gatewaysQuery.error.message
          : "Failed to load gateways. Please try again later.";
      toast.error(message);
    }
  }, [gatewaysQuery.isError, gatewaysQuery.error]);

  return (
    <DashboardLayout submenu={null}>
      <GatewaysTable
        gateways={gateways}
        staleTime={staleTime}
        handleStaleTimeChange={handleStaleTimeChange}
        isLoading={gatewaysQuery.isLoading}
      />
    </DashboardLayout>
  );
}
